import { hasCapability, type User } from "../base";

export const reviewRevenueAutoComplete = {
  read: (user: User) => hasCapability(user, "reviewRevenueAutoComplete.read"),
};
